export default __webpack_public_path__ + "search-examples-category-based-search-thumbnail-480-56044771ba22bd7272bb6a3ff17b22fb.webp";